module.exports = __webpack_public_path__ + "img/logo.46c1060e.svg";